import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Pagination } from "../components/pagination/Pagination";
import jwtAxios from "../apiAxios/axios";
import Modal from "../components/popup/MultipMappingPopUp";
import { formatDate } from "../utils";
import Loading from "../components/loading/GlobalLoader";
import { useNavigate } from "react-router-dom";

const ITEMS_PER_PAGE = 10;

const InvoiceTable = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [invoices, setInvoices] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [mergedInvoices, setMergedInvoices] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchInvoices();
    }, [currentPage]);

    const fetchInvoices = async () => {
        setLoading(true);
        try {
            const response = await jwtAxios.get(`/users/get-master-invoice?page=${currentPage}&limit=${ITEMS_PER_PAGE}`);
            setInvoices(response.data.invoices);
            setTotalItems(response.data.totalInvoices);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        }
        setLoading(false);
    };




    const handleMergedClick = (invoices) => {
        setMergedInvoices(invoices);
    };

    const handleCloseMergedModal = () => {
        setMergedInvoices(null);
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="p-8  min-h-screen"
        >
            <div className="max-w-full mx-auto">
                {/* <h2 className="text-4xl font-bold mb-8 text-gray-900 text-center">Invoice Management</h2> */}
                <div className="bg-white rounded-xl shadow-lg overflow-hidden p-6">
                    {loading ? (
                        <Loading isLoading={loading} />
                    ) : (
                        <table className="w-full border-collapse border border-gray-300 text-left">
                            <thead>
                                <tr className="bg-gradient-to-r from-purple-600 to-blue-500 text-white">
                                    <th className="py-3 px-4 border-b">S.No</th>
                                    <th className="py-3 px-4 border-b">Master Invoice</th>
                                    <th className="py-3 px-4 border-b">Name</th>
                                    <th className="py-3 px-4 border-b">Bill To</th>
                                    <th className="py-3 px-4 border-b">Created Date</th>
                                    <th className="py-3 px-4 border-b">Merged Invoices</th>
                                    <th className="py-3 px-4 border-b">Total Amount</th>
                                    <th className="py-3 px-4 border-b text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoices?.length > 0 ? (
                                    invoices.map((invoice, index) => (
                                        <motion.tr
                                            key={invoice.id}
                                            initial={{ opacity: 0, y: 10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3, delay: index * 0.1 }}
                                            className="hover:bg-gray-50 transition-colors border-b"
                                        >
                                            <td className="py-3 px-4 text-gray-700">{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                                            <td className="py-3 px-4 text-blue-600 font-semibold">{invoice.masterInvoiceNumber}</td>
                                            <td className="py-3 px-4 text-blue-600 font-semibold">{invoice.invoiceName}</td>
                                            <td className="py-3 px-4 text-blue-600 font-semibold">{invoice?.billTo?.name}</td>
                                            <td className="py-3 px-4 text-gray-600">{formatDate(invoice.createdAt)}</td>
                                            <td className="py-3 px-4 text-gray-600">
                                                <button
                                                    onClick={() => handleMergedClick(invoice.invoiceNumber)}
                                                    className="bg-gray-200 px-3 py-1 rounded-full text-sm text-blue-700 font-semibold hover:bg-gray-300 transition"
                                                >
                                                    {invoice.invoiceNumber?.length} {invoice.invoiceNumber?.length==1?"invoice":"invoices"}
                                                </button>
                                            </td>
                                            <td className="py-3 px-4 text-blue-600 font-semibold">{invoice?.totals?.totalBeforeTax}</td>

                                            <td className="py-3 px-4 text-center">
                                                <button
                                                    onClick={() => navigate(`/master-invoice-details/${invoice.masterInvoiceNumber}`)}
                                                    className="px-4 py-2 bg-gradient-to-br from-purple-600 to-blue-500 text-white rounded-lg hover:bg-gradient-to-bl transition font-semibold"
                                                >
                                                    View Details
                                                </button>
                                            </td>
                                        </motion.tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="py-4 text-center text-gray-600">
                                            No invoices found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
                <Pagination totalItems={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={setCurrentPage} />
            </div>

            {/* Merged Invoices Modal */}
            <Modal isOpen={mergedInvoices} onClose={handleCloseMergedModal} title="Merged Invoices">
                <ul className="space-y-3">
                    {mergedInvoices?.map((invoice, index) => (
                        <li
                            key={index}
                            className="flex items-center space-x-3 bg-gray-100 rounded-lg px-4 py-2 shadow-sm"
                        >
                            <span className="text-blue-600 font-semibold">{invoice}</span>
                        </li>
                    ))}
                </ul>
            </Modal>
        </motion.div>
    );
};

export default InvoiceTable;
